exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/debian/git/lea/lea-front/src/app/shared/cours/search-cours-collectif/search-cours-collectif.component.scss
// module id = ../../../../../src/app/shared/cours/search-cours-collectif/search-cours-collectif.component.scss
// module chunks = main